import { failureType, requestType, successType } from 'src/services/api-handlers/api-resolver';
import { Paginated } from '../../services/api-handlers/pagination';

import { Actions } from '../actions/caseNoConsent-actions';
import { CaseNoConsentActions } from '../constants';
import { ICaseNoConsent } from 'src/types/caseNoConsent';

export interface CaseNoConsentState {
    inProgress: boolean;
    authCode: string;
    error: string;
    data: Paginated<ICaseNoConsent>;
    current: ICaseNoConsent | null;
    currentFiles: any | null;
}

const initialState = {
    inProgress: false,
    authCode: '',
    error: '',
    data: {
        inProgress: false,
        list: [],
        page: 1,
        meta: {
            updatedAt: null,
        },
    },
    current: null,
    currentFiles: null,
};

export function casesNoConsent(state: CaseNoConsentState = initialState, action: Actions | any): CaseNoConsentState {
    switch (action.type) {
        case requestType(CaseNoConsentActions.PERSIST_CASE_NO_CONSENT):
            return { ...state, error: '', inProgress: true };
        case successType(CaseNoConsentActions.PERSIST_CASE_NO_CONSENT):
            return { ...state, inProgress: false };
        case failureType(CaseNoConsentActions.PERSIST_CASE_NO_CONSENT):
            return { ...state, error: action.error, inProgress: false };

        case requestType(CaseNoConsentActions.FETCH_CASE_NO_CONSENTS):
            return {
                ...state,
                data: {
                    ...state.data,
                    list: [],
                    meta: state.data?.meta?.updatedAt
                        ? state.data?.meta
                        : {
                              updatedAt: null,
                          },
                    inProgress: true,
                },
                error: '',
                inProgress: true,
            };
        case successType(CaseNoConsentActions.FETCH_CASE_NO_CONSENTS):
            return { ...state, data: { ...action.payload, inProgress: false }, inProgress: false };
        case failureType(CaseNoConsentActions.FETCH_CASE_NO_CONSENTS):
            return { ...state, data: { ...state.data, inProgress: false }, error: action.error, inProgress: false };

        case requestType(CaseNoConsentActions.FETCH_CASE_NO_CONSENT):
            return { ...state, inProgress: true, current: null, error: '' };
        case successType(CaseNoConsentActions.FETCH_CASE_NO_CONSENT):
            return { ...state, inProgress: false, current: action.payload };
        case failureType(CaseNoConsentActions.FETCH_CASE_NO_CONSENT):
            return { ...state, inProgress: false, error: action.error };
        case requestType(CaseNoConsentActions.DELETE_CASE_NO_CONSENT):
            return { ...state, error: '', inProgress: true };
        case successType(CaseNoConsentActions.DELETE_CASE_NO_CONSENT):
            return {
                ...state,
                inProgress: false,
                data: {
                    ...state.data,
                    list: state.data.list.filter((user: ICaseNoConsent) => {
                        return user.id !== action.payload.id;
                    }),
                    meta: {
                        updatedAt: 0,
                    },
                },
            };
        case failureType(CaseNoConsentActions.DELETE_CASE_NO_CONSENT):
            return { ...state, inProgress: false, error: action.error.response.data?.errorMessage ?? 'Unknown error' };
        default:
            return state;
    }
}
